import { createAction, PayloadActionCreator } from '@reduxjs/toolkit';
import { Affiliate, Donation } from '../../../types/PaymentTypes';

export const initialPaymentFlow: PayloadActionCreator<{
  paymentFlowId: string;
}> = createAction('payment/initialPaymentFlow');

export const startPaymentFlow: PayloadActionCreator<void> = createAction(
  'payment/startPaymentFlow',
);

export const persistPaymentFlow: PayloadActionCreator<void> = createAction(
  'payment/persistPaymentFlow',
);

export const completePaymentFlow: PayloadActionCreator<void> = createAction(
  'payment/completePaymentFlow',
);

export const updateActiveDonation: PayloadActionCreator<Partial<Donation>> = createAction(
  'payment/updateActiveDonation',
);

export const updateAffiliate: PayloadActionCreator<Partial<Affiliate>> = createAction(
  'payment/updateAffiliate',
);
